<template>
    <h1 class="logotitle-wrapper">
        <router-link to="/" class="logotitle-link">
            <span class="logotitle-span">
                KRAKEN <br> LABS
                <img class="logotitle-img" :src="require(`@/assets/img/aro-kraken.png`)" alt="">
                <span class="logotitle-span-subtitle">Creative Web Design</span>
            </span>
        </router-link>
    </h1>
</template>

<script lang="ts">
    import Vue from 'vue';
    import gsap, { Power2, Elastic } from 'gsap';

    export default Vue.extend({
        name: 'LogoTitle',
        data() {
            return {
                logoSrc: require(`@/assets/img/aro-kraken.png`)
            }
        },
        methods: {
            animateLogo() {
                const logoWrapperElement  = document.querySelector('.logotitle-wrapper');
                const logoImgElement      = document.querySelector('.logotitle-img');
                const logoSubtitleElement = document.querySelector('.logotitle-span-subtitle');

                const tl = gsap.timeline();
                tl.to(logoWrapperElement, 3.6, {transform: 'scale(1)  translate(0, 0)', webkitTransform: 'scale(1)  translate(0, 0)', ease: Power2.easeOut}, 0)
                tl.to(logoImgElement, .8, {bottom: 0, ease: Elastic.easeOut}, '>')
                tl.to(logoSubtitleElement, .8, {left: '101.5%', ease: Power2.easeOut}, '-=.5')
            }
        },
        mounted() {
            this.animateLogo();
        }
    })
</script>

<style scoped lang="scss">
    .logotitle {
        &-wrapper {
            text-align: right;
            font-size: 5rem;
            color: #fff;
            position: relative;
            z-index: 1;
            transform: scale(75) translate(-10%, -14%);
            -webkit-transform: scale(75) translate(-10%, -14%);
        }

        &-link {
            color: #fff;
            text-decoration: none;
            &:hover {
                text-decoration: none;
            }
        }

        &-span {
            position: relative;

            & img {
                position: absolute;
                left: 0;
                bottom: 30vh;
                height: 50%;
            }

            &-subtitle {
                position: absolute;
                left: 150%;
                top: 1.2rem;
                font-size: .83rem;
                writing-mode: vertical-rl;
                font-weight: 400;
                letter-spacing: 1.5px;
            }
        }

        @media SCREEN AND ( min-width: 576px ) {
            &-wrapper {
                font-size: 6rem;
            }

            &-span {
                &-subtitle {
                    left: 150%;
                    top: 1.5rem;
                    font-size: 1rem;
                }
            }
        }
    }
</style>